module.exports = __webpack_public_path__ + "static/media/Spin.8c5d09b3.svg";